export function formatWeekday(dateString: any): string {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return '';
  }

  const format = new Intl.DateTimeFormat('de-CH', {
    weekday: 'long',
  }).format;

  return format(date);
}
